document.addEventListener('DOMContentLoaded', function () {
  // Rota los mensajes de la barra de anuncio cada 4 segundos
  var messages = document.querySelectorAll('.announcement-bar__track p');
  if (messages.length > 1) {
    var current = 0;
    messages.forEach(function (m, i) { m.style.display = i === 0 ? 'block' : 'none'; });
    setInterval(function () {
      messages[current].style.display = 'none';
      current = (current + 1) % messages.length;
      messages[current].style.display = 'block';
    }, 4000);
  }

  // Galería de producto: cambiar imagen principal al tocar una miniatura
  var thumbs = document.querySelectorAll('[data-gallery-thumb]');
  var mainImages = document.querySelectorAll('[data-gallery-image]');
  if (thumbs.length && mainImages.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(thumb.getAttribute('data-gallery-thumb'), 10);
        mainImages.forEach(function (img, i) {
          img.classList.toggle('is-active', i === index);
        });
        thumbs.forEach(function (t, i) {
          t.classList.toggle('is-active', i === index);
        });
      });
    });
  }

  initCart();
  initProductForm();
});

/* ---------------------------------------------------------------------------
 * Ficha de producto: al cambiar la variante (talla) actualiza precio,
 * disponibilidad, stock, la variante que se agrega al carrito y la imagen
 * ------------------------------------------------------------------------- */
function initProductForm() {
  var product = document.querySelector('[data-product]');
  var info = product && product.querySelector('[data-product-info]');
  var dataEl = info && info.querySelector('[data-variants-json]');
  if (!info || !dataEl) return;

  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var selects = info.querySelectorAll('[data-option-select]');
  if (!selects.length) return;

  var idInput = info.querySelector('[data-variant-id]');
  var priceEl = info.querySelector('[data-price]');
  var compareEl = info.querySelector('[data-compare-price]');
  var addBtn = info.querySelector('[data-add-to-cart]');
  var addBtnText = info.querySelector('[data-add-to-cart-text]');
  var stockEl = info.querySelector('[data-stock-message]');
  var galleryMain = product.querySelectorAll('[data-gallery-image]');
  var galleryThumbs = product.querySelectorAll('[data-gallery-thumb]');

  function selectedOptions() {
    return Array.prototype.map.call(selects, function (s) { return s.value; });
  }

  function matchVariant(opts) {
    return variants.filter(function (v) {
      return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
    })[0];
  }

  function showGalleryImage(index) {
    if (index < 0 || !galleryMain[index]) return;
    galleryMain.forEach(function (img, i) { img.classList.toggle('is-active', i === index); });
    galleryThumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
  }

  function update() {
    var v = matchVariant(selectedOptions());

    if (!v) {
      if (idInput) idInput.value = '';
      if (priceEl) priceEl.textContent = '—';
      if (compareEl) compareEl.hidden = true;
      if (addBtn) addBtn.disabled = true;
      if (addBtnText) addBtnText.textContent = 'No disponible';
      if (stockEl) stockEl.hidden = true;
      return;
    }

    if (idInput) idInput.value = v.id;
    if (priceEl) priceEl.textContent = v.price;

    if (compareEl) {
      if (v.on_sale) {
        compareEl.textContent = v.compare_at_price;
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (addBtn) addBtn.disabled = !v.available;
    if (addBtnText) addBtnText.textContent = v.available ? 'Agregar al carrito' : 'Agotado';

    if (stockEl) {
      if (!v.available) {
        stockEl.textContent = '✗ Esta talla está agotada por ahora.';
        stockEl.className = 'stock-message stock-message--error';
        stockEl.hidden = false;
      } else if (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 5) {
        stockEl.textContent = v.inventory_quantity === 1
          ? '⚠ Solo queda 1 unidad.'
          : '⚠ Solo quedan ' + v.inventory_quantity + ' unidades.';
        stockEl.className = 'stock-message stock-message--warning';
        stockEl.hidden = false;
      } else {
        stockEl.hidden = true;
      }
    }

    if (v.featured_media_position > 0) {
      showGalleryImage(v.featured_media_position - 1);
    }

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', update); });
  update();
}

/* ---------------------------------------------------------------------------
 * Carrito: actualización en vivo (cantidad / eliminar) sin recargar la página
 * ------------------------------------------------------------------------- */
function initCart() {
  var root = document.querySelector('[data-cart-root]');
  if (!root || !root.querySelector('.cart-form')) return;

  var section = root.closest('.shopify-section');
  var sectionId = section ? section.id.replace('shopify-section-', '') : null;
  var busy = false;

  function setBusy(state) {
    busy = state;
    root.classList.toggle('cart-page--loading', state);
    root.querySelectorAll('input, button').forEach(function (el) { el.disabled = state; });
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = count; });
  }

  function change(key, quantity) {
    if (busy) return;
    setBusy(true);

    var body = { id: key, quantity: quantity };
    if (sectionId) body.sections = sectionId;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);

        var html = cart.sections && sectionId ? cart.sections[sectionId] : null;
        if (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-root]');
          if (fresh) {
            root.innerHTML = fresh.innerHTML;
          } else {
            root.innerHTML = html;
          }
        } else {
          window.location.reload();
          return;
        }
        setBusy(false);
      })
      .catch(function () {
        setBusy(false);
        window.location.reload();
      });
  }

  function rowKey(el) {
    var row = el.closest('[data-cart-row]');
    return row ? row.getAttribute('data-key') : null;
  }

  // Delegación: sobrevive al reemplazo de innerHTML tras cada actualización
  root.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    var remove = e.target.closest('[data-cart-remove]');

    if (minus || plus) {
      var input = e.target.closest('[data-qty-stepper]').querySelector('[data-qty-input]');
      var val = parseInt(input.value, 10) || 0;
      var next = plus ? val + 1 : Math.max(0, val - 1);
      if (next === val) return;
      input.value = next;
      change(rowKey(e.target), next);
    }

    if (remove) {
      e.preventDefault();
      change(rowKey(remove), 0);
    }
  });

  root.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var next = Math.max(0, parseInt(input.value, 10) || 0);
    input.value = next;
    change(rowKey(input), next);
  });
}
